<script setup lang="ts">
/** CDD Legal Arrangement (TMP005) 문서 본문. 체크박스 if-wrap at_*. */
import { inject } from 'vue';
import { CDD_DOC_CTX } from './cddContext';
import { CDD_DOCS } from './cddFields';
import CddHeader from './CddHeader.vue';
import CddPersonTransacting from './CddPersonTransacting.vue';
import CddDeclaration from './CddDeclaration.vue';
import CddVerification from './CddVerification.vue';
import CddDocVarField from './CddDocVarField.vue';

const ctx = inject(CDD_DOC_CTX)!;
const TYPES = CDD_DOCS.legal_arrangement.checkboxGroup!.options;
const parties = [
  { role: 'Settlor', cn: '委托人', p: 'la_settlor' }, { role: 'Trustee', cn: '受托人', p: 'la_trustee' },
  { role: 'Protector (if any)', cn: '监护人', p: 'la_protector' }, { role: 'Beneficiary/class', cn: '受益人', p: 'la_beneficiary' },
  { role: 'Other BO information', cn: '其他 BO', p: 'la_other_bo' },
];
</script>

<template>
  <div>
    <CddHeader />
    <table class="cdd-tbl" style="margin-top:14px"><tbody>
      <tr><td class="cdd-sec" colspan="2">3) For LEGAL ARRANGEMENT <span class="cdd-cn">关于法律安排</span></td></tr>
      <tr><td class="cdd-lcell">Name <span class="cdd-cn">名称</span></td><td><CddDocVarField field-key="la_name" /></td></tr>
      <tr><td class="cdd-lcell">Registration No. <span class="cdd-cn">注册号码</span></td><td><CddDocVarField field-key="la_registration_no" /></td></tr>
      <tr>
        <td class="cdd-lcell">Type <span class="cdd-cn">类型</span></td>
        <td>
          <span v-for="t in TYPES" :key="t.value" class="cdd-cbx" @click="ctx.setCheckbox(t.value)">
            <v-icon size="15" class="box" :color="ctx.checkboxValue.value === t.value ? 'primary' : ''">{{ ctx.checkboxValue.value === t.value ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>{{ t.label }}<template v-if="t.value === 'at_other'"> <span class="cdd-cn">其他人</span>: <CddDocVarField field-key="la_other_type" /></template>
          </span>
        </td>
      </tr>
      <tr><td class="cdd-lcell">Country of Registration <span class="cdd-cn">注册国家</span></td><td><CddDocVarField field-key="la_country_of_registration" /></td></tr>
      <tr><td class="cdd-lcell">Registered Office Address <span class="cdd-cn">注册办公地址</span></td><td><CddDocVarField field-key="la_registered_address" /></td></tr>
      <tr><td class="cdd-lcell">Town <span class="cdd-cn">城镇</span></td><td><CddDocVarField field-key="la_town" /></td></tr>
      <tr><td class="cdd-lcell">State <span class="cdd-cn">州际</span></td><td><CddDocVarField field-key="la_state" /></td></tr>
      <tr><td class="cdd-lcell">Postcode <span class="cdd-cn">邮政编码</span> &nbsp; <CddDocVarField field-key="la_postcode" /></td><td>Country <span class="cdd-cn">乡村/国家</span> &nbsp; <CddDocVarField field-key="la_country" /></td></tr>
      <tr><td class="cdd-lcell">Principal Place of Activity (if different)</td><td><CddDocVarField field-key="la_activity_address" /></td></tr>
      <tr><td class="cdd-lcell">Town <span class="cdd-cn">城镇</span></td><td><CddDocVarField field-key="la_activity_town" /></td></tr>
      <tr><td class="cdd-lcell">State <span class="cdd-cn">州际</span></td><td><CddDocVarField field-key="la_activity_state" /></td></tr>
      <tr><td class="cdd-lcell">Postcode <span class="cdd-cn">邮政编码</span> &nbsp; <CddDocVarField field-key="la_activity_postcode" /></td><td>Country <span class="cdd-cn">乡村/国家</span> &nbsp; <CddDocVarField field-key="la_activity_country" /></td></tr>
      <tr><td class="cdd-lcell">Principle Activity <span class="cdd-cn">主要活动</span></td><td><CddDocVarField field-key="la_principle_activity" /></td></tr>
      <tr><td class="cdd-lcell">Contact No. <span class="cdd-cn">联系号码</span></td><td><CddDocVarField field-key="la_contact_no" /></td></tr>
      <tr><td class="cdd-lcell">Purpose of Transaction <span class="cdd-cn">交易目的</span></td><td><CddDocVarField field-key="la_purpose_of_txn" /></td></tr>
      <tr><td class="cdd-lcell">Directors/Partners <span class="cdd-cn">董事/合伙人姓名</span></td><td><CddDocVarField field-key="la_directors_partners" /></td></tr>
    </tbody></table>

    <table class="cdd-tbl" style="margin-top:14px"><tbody>
      <tr><th style="width:22%"></th><th>Name <span class="cdd-cn">名称</span></th><th>ID <span class="cdd-cn">身份证</span></th><th>Address <span class="cdd-cn">地址</span></th></tr>
      <tr v-for="p in parties" :key="p.p"><td>{{ p.role }} <span class="cdd-cn">{{ p.cn }}</span></td><td><CddDocVarField :field-key="`${p.p}_name`" /></td><td><CddDocVarField :field-key="`${p.p}_id`" /></td><td><CddDocVarField :field-key="`${p.p}_address`" /></td></tr>
      <tr><td>Relationship with trust <span class="cdd-cn">与信托的关系</span></td><td colspan="3"><CddDocVarField field-key="la_relationship" /></td></tr>
    </tbody></table>

    <CddPersonTransacting />
    <CddDeclaration />
    <CddVerification />
  </div>
</template>
